"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _cccisdDataviz = _interopRequireDefault(require("cccisd-dataviz"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppDefs = window.cccisd.appDefs;
var BarChartReportGroup = /*#__PURE__*/function (_Component) {
  _inherits(BarChartReportGroup, _Component);
  // render invididual table row for group log tab
  function BarChartReportGroup(props) {
    var _this;
    _classCallCheck(this, BarChartReportGroup);
    _this = _callSuper(this, BarChartReportGroup, [props]);
    // render comment box
    _defineProperty(_assertThisInitialized(_this), "_renderCommentBox", function (name, dateStr, comment) {
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].commentInfo
      }, /*#__PURE__*/_react["default"].createElement("h2", null, name), /*#__PURE__*/_react["default"].createElement("span", null), /*#__PURE__*/_react["default"].createElement("h3", {
        className: _style["default"].blueHeader
      }, dateStr)), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("p", null, comment));
    });
    _defineProperty(_assertThisInitialized(_this), "_getSubScaleDataSeries", function (subscale) {
      var series = [];
      var firstRow = [''];
      if (_this.state.hasTargetLine) {
        firstRow.push('THRESHOLD');
      }
      // applicability
      var outcomes = (0, _filter2["default"])(AppDefs.sessions.fixedSettings.sessions, function (s) {
        return s.type === 'outcome';
      });
      var applicableOutcomes = [];
      outcomes.forEach(function (item) {
        var match = item.activities.find(function (a) {
          return a.handle === _this.props.reportProps.outcomeHandle;
        });
        if (match) {
          applicableOutcomes.push(match);
        }
      });
      if (subscale !== undefined) {
        var currentSeries = (0, _find2["default"])(_this.props.reportProps.subScales, function (ss) {
          return ss.handle === subscale;
        });
        if ('reporterSeries' in currentSeries) {
          var reporters = currentSeries.reporterSeries;
          reporters.forEach(function (s) {
            if (!(0, _isNil2["default"])(s.label)) {
              firstRow.push(s.label);
              firstRow.push({
                role: 'annotation'
              });
            }
          });
          series.push(firstRow);
          applicableOutcomes.forEach(function (o) {
            series.push(_this._getSessionRow(o, reporters));
          });
        }
      } else {
        var _reporters = _this.props.reportProps.reporterSeries;
        _reporters.forEach(function (s) {
          if (!(0, _isNil2["default"])(s.label)) {
            firstRow.push(s.label);
            firstRow.push({
              role: 'annotation'
            });
          }
        });
        series.push(firstRow);
        applicableOutcomes.forEach(function (o) {
          series.push(_this._getSessionRow(o, _reporters));
        });
      }
      return series;
    });
    _defineProperty(_assertThisInitialized(_this), "_getSessionRow", function (outcome, sortedSeries) {
      var row = [];
      sortedSeries.forEach(function (ss, i) {
        if (i === 0) {
          if (_this.state.hasTargetLine) {
            row.push(ss.label);
            row.push(_this.state.targetLineValue);
          } else {
            row.push(ss.label);
          }
        }
        if (Array.isArray(_this.props.reportData)) {
          if (!_this.props.reportData[i].devTags[ss.devTag]) {
            row.push(0);
            row.push(null);
          } else {
            row.push(_this._handleDecimals(+_this.props.reportData[i].devTags[ss.devTag]));
            row.push(_this._handleDecimals(+_this.props.reportData[i].devTags[ss.devTag]));
          }
        } else if (_typeof(_this.props.reportData) === 'object') {
          if (!_this.props.reportData.devTags[ss.devTag]) {
            row.push(0);
            row.push(null);
          } else {
            row.push(_this._handleDecimals(+_this.props.reportData.devTags[ss.devTag]));
            row.push(_this._handleDecimals(+_this.props.reportData.devTags[ss.devTag]));
          }
        }
      });
      return row;
    });
    _defineProperty(_assertThisInitialized(_this), "_handleDecimals", function (number) {
      var decimalPlaces = 0;
      var hasDecimalPlaces = !(0, _isNil2["default"])(_this.props.reportProps.decimalPlaces) && _this.props.reportProps.decimalPlaces !== 0;
      if (hasDecimalPlaces) {
        decimalPlaces = _this.props.reportProps.decimalPlaces;
        var roundedNumber = number.toFixed(decimalPlaces);
        return +roundedNumber;
      }
      return Math.round(+number);
    });
    _defineProperty(_assertThisInitialized(_this), "_getDataSeries", function (data) {
      var series = [];
      var reportProps = _this.props.reportProps;
      var showScore = !(0, _isNil2["default"])(reportProps.showScore);
      var labelRow = [''];
      var dataRows = [];
      if (reportProps.targetLine) {
        labelRow.push('THRESHOLD');
      }
      var reporters = data;
      reporters.forEach(function (s) {
        var newRow = [];
        var index = reporters.indexOf(s);
        var hasDivideBy = !(0, _isNil2["default"])(reportProps.divideBy);
        var hasLabel = !(0, _isNil2["default"])(s.label);
        if (hasLabel) {
          labelRow.push(s.label);
          newRow.push(s.label);
          if (showScore && reportProps.showScore) {
            labelRow.push({
              role: 'annotation'
            });
          }
        } else {
          labelRow.push('');
          newRow.push(s.label);
          if (showScore && reportProps.showScore) {
            labelRow.push({
              role: 'annotation'
            });
          }
        }
        if (reportProps.targetLine) {
          newRow.push(+reportProps.targetLine);
        }
        for (var i = 0; i < reporters.length; i++) {
          if (i === index) {
            if (hasDivideBy) {
              newRow.push(Math.round(+s.score / reportProps.divideBy));
              if (showScore && reportProps.showScore) {
                if (+s.score === 0) {
                  newRow.push(null);
                } else {
                  newRow.push(Math.round(+s.score / reportProps.divideBy));
                }
              }
            } else {
              newRow.push(+s.score);
              if (showScore && reportProps.showScore) {
                if (+s.score === 0) {
                  newRow.push(null);
                } else {
                  newRow.push(Math.round(+s.score));
                }
              }
            }
          } else {
            newRow.push(0);
            if (showScore && reportProps.showScore) {
              newRow.push(null);
            }
          }
        }

        // if (showScore && reportProps.showScore) {
        //     // blah
        //     if (hasDivideBy) {
        //         newRow.push(+s.score / reportProps.divideBy);
        //     } else {
        //         newRow.push(+s.score);
        //     }
        // }

        dataRows.push(newRow);
      });

      // if (showScore && reportProps.showScore) {
      //     labelRow.push({ role: 'annotation' });
      // }

      series.push(labelRow);
      var result = series.concat(dataRows);
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "_getSubChartObject", function (subscale) {
      return {
        chartType: 'ColumnChart',
        dataTable: _this._getSubScaleDataSeries(subscale),
        options: _this._getBarChartOptions(subscale)
      };
    });
    _defineProperty(_assertThisInitialized(_this), "_getChartObject", function (data) {
      return {
        chartType: 'ColumnChart',
        dataTable: _this._getDataSeries(data),
        options: _this._getBarChartOptions(data, _this._getDataSeries(data))
      };
    });
    _defineProperty(_assertThisInitialized(_this), "_getSeriesForReporters", function (data, chartData) {
      var series = [];
      var accountForTargetLineIndex = 0;
      var reportProps = _this.props.reportProps;
      if (reportProps.targetLine) {
        accountForTargetLineIndex = 1;
        series[0] = {
          tooltip: true,
          enableInteractivity: false,
          visibleInLegend: false,
          type: 'steppedArea',
          areaOpacity: 0,
          pointSize: 3,
          opacity: 0.1,
          annotations: {
            testStyle: {
              fontSize: 14
            }
          }
        };
      }
      if (!(0, _isUndefined2["default"])(_this.state.currentSubscale)) {
        var currentSeries = (0, _find2["default"])(_this.props.reportProps.subScales, function (ss) {
          return ss.handle === _this.state.currentSubscale;
        });
        if ('reporterSeries' in currentSeries) {
          var reporters = currentSeries.reporterSeries;
          reporters.forEach(function (s, index) {
            series[index + 2] = {
              pointSize: 6
            };
          });
        } else {
          series[accountForTargetLineIndex] = {
            visibleInLegend: false
          };
        }
      } else {
        var _reporters2 = data;
        _reporters2.forEach(function (s, index) {
          series[index + 2] = {
            pointSize: 6,
            axis: s.label,
            annotations: {
              textStyle: {
                fontSize: 14
              }
            }
          };
        });
      }
      return series;
    });
    // get display options for chart based on passed in typesdfd
    _defineProperty(_assertThisInitialized(_this), "_getBarChartOptions", function (data, chartData) {
      return {
        legend: {
          position: 'none'
        },
        width: 700,
        height: 350,
        annotations: {
          alwaysOutside: true
        },
        bar: {
          groupWidth: '50%'
        },
        chartArea: {
          left: 40,
          width: '100%'
        },
        series: _this._getSeriesForReporters(data, chartData),
        vAxis: {
          gridlines: {
            color: '#D3D3D3'
          },
          minorGridlines: {
            color: 'transparent'
          },
          ticks: _this._getVericalScale(),
          title: _this.props.reportProps.yAxisLabel,
          titleTextStyle: {
            italic: false,
            color: '#999999'
          },
          viewWindow: {
            min: _this.props.reportProps.verticalScaleMin,
            max: _this.props.reportProps.verticalScaleMax
          }
        }
      };
    });
    _defineProperty(_assertThisInitialized(_this), "_getVericalScale", function () {
      var verticalTicks = [];
      var min = +_this.props.reportProps.verticalScaleMin;
      var max = +_this.props.reportProps.verticalScaleMax;
      var interval = +_this.props.reportProps.verticalScaleInterval;
      if (!(0, _isUndefined2["default"])(_this.state.currentSubscale) && 'verticalScaleMin' in (0, _find2["default"])(_this.props.reportProps.subScales, function (ss) {
        return ss.handle === _this.state.currentSubscale;
      })) {
        var currentSubscale = (0, _find2["default"])(_this.props.reportProps.subScales, function (ss) {
          return ss.handle === _this.state.currentSubscale;
        });
        min = +currentSubscale.verticalScaleMin;
        max = +currentSubscale.verticalScaleMax;
        interval = +currentSubscale.verticalScaleInterval;
      } else {
        min = +_this.props.reportProps.verticalScaleMin;
        max = +_this.props.reportProps.verticalScaleMax;
      }
      if (!interval) {
        if (max <= 5) {
          interval = 1;
        } else if (max < 25 && max > 5) {
          interval = 2;
        } else if (max >= 25 && max < 50) {
          interval = 5;
        } else if (max >= 50 && max < 90) {
          interval = 10;
        } else if (max > 90) {
          interval = 20;
        }
      }
      for (var i = min; i <= max;) {
        verticalTicks.push(i);
        i += interval;
      }
      return verticalTicks;
    });
    _defineProperty(_assertThisInitialized(_this), "_formatMetricsList", function (data) {
      var reportProps = _this.props.reportProps;
      var list = [];
      data.forEach(function (item) {
        var dataSet = {};
        dataSet.score = item.devTags[reportProps.dataPath];
        dataSet.label = item.devTags[reportProps.labelPath];
        list.push(dataSet);
      });
      return list;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderSubscales", function () {
      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: _style["default"].horzList
      }, _this.props.reportProps.subScales.map(function (ss, index) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: index,
          onClick: _this.onSubscaleClick.bind(null, ss)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames2["default"])(_defineProperty(_defineProperty({}, _style["default"].chartArea, true), _style["default"].active, ss.handle === _this.state.currentSubscale))
        }, /*#__PURE__*/_react["default"].createElement("h1", null, 'navLabel' in ss ? ss.navLabel : ss.label)));
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "onSubscaleClick", function (ss) {
      if (_this.state.currentSubscale !== ss.handle) {
        var hasTargetLine = false;
        var targetLineValue = 0;
        var selectedSubScale = (0, _find2["default"])(_this.props.reportProps.subScales, function (subscale) {
          return subscale.handle === ss.handle;
        });
        if ('targetLineValue' in selectedSubScale) {
          hasTargetLine = true;
          targetLineValue = selectedSubScale.targetLineValue;
        }
        _this.setState({
          currentSubscale: ss.handle,
          hasTargetLine: hasTargetLine,
          targetLineValue: targetLineValue
        });
      }
    });
    var _hasTargetLine = false;
    var _currentSubscale;
    var _targetLineValue = 0;
    if ('subScales' in props.reportProps) {
      _currentSubscale = props.reportProps.subScales[0].handle;
    }
    if (_currentSubscale === undefined && 'targetLine' in props.reportProps) {
      _hasTargetLine = true;
      _targetLineValue = props.reportProps.targetLineValue;
    } else if (_currentSubscale && 'subScales' in _this.props.reportProps && 'targetLine' in (0, _find2["default"])(_this.props.reportProps.subScales, function (ss) {
      return ss.handle === _currentSubscale;
    })) {
      _hasTargetLine = true;
      _targetLineValue = (0, _find2["default"])(_this.props.reportProps.subScales, function (ss) {
        return ss.handle === _currentSubscale;
      }).targetLine;
    }
    _this.state = {
      hasTargetLine: _hasTargetLine,
      targetLineValue: _targetLineValue,
      currentSubscale: _currentSubscale
    };
    return _this;
  }
  _createClass(BarChartReportGroup, [{
    key: "render",
    value:
    // final render
    function render() {
      var _this2 = this;
      var _this$props = this.props,
        isReport = _this$props.isReport,
        reportProps = _this$props.reportProps,
        reportData = _this$props.reportData;
      var formattedData;
      if (!reportProps.subScales) {
        formattedData = this._formatMetricsList(reportData);
      }
      var hasReportData = !(0, _isEmpty2["default"])(reportData) && !(0, _isNil2["default"])(reportData);
      var hasChartDescription = reportProps.chartDescription !== '' && !(0, _isNil2["default"])(reportProps.chartDescription);
      var hasChartNote = reportProps.chartNote !== '' && !(0, _isNil2["default"])(reportProps.chartNote);
      var currentSubscaleObj = {};
      if (!(0, _isUndefined2["default"])(this.state.currentSubscale)) {
        currentSubscaleObj = (0, _find2["default"])(this.props.reportProps.subScales, function (ss) {
          return ss.handle === _this2.state.currentSubscale;
        });
      }
      var reportStyle = isReport ? _style["default"].report + ' ' + _style["default"].paginated : _style["default"].report;
      var otherPages = [];
      if (isReport && 'subScales' in this.props.reportProps) {
        this.props.reportProps.subScales.forEach(function (subScale, index) {
          if (subScale.handle !== _this2.state.currentSubscale) {
            otherPages.push( /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].reportWrapper
            }, _this2.props.header, /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].reportContentWrapper
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].contentWrapper
            }, /*#__PURE__*/_react["default"].createElement("h1", null, _this2.props.reportProps.reportTitle), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
              content: _this2.props.reportProps.description
            }), /*#__PURE__*/_react["default"].createElement("h2", {
              style: {
                fontSize: '28px'
              }
            }, subScale.label), /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                marginTop: '20px'
              }
            }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
              content: subScale.description
            })), /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].chartContent
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].barChart,
              key: index
            }, /*#__PURE__*/_react["default"].createElement(_cccisdDataviz["default"], {
              chartData: _this2._getSubChartObject(subScale.handle)
            }))))))));
          }
        });
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: reportStyle
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Report, {
        showPagination: isReport
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].toPdf
      }, !reportProps.subScales && /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportContentWrapper
      }, this.props.header, hasReportData ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].contentWrapper
      }, /*#__PURE__*/_react["default"].createElement("h1", null, reportProps.reportTitle), /*#__PURE__*/_react["default"].createElement("h2", null, reportProps.description), hasChartDescription && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].chartText
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: reportProps.chartDescription
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].chartContent
      }, /*#__PURE__*/_react["default"].createElement(_cccisdDataviz["default"], {
        chartData: this._getChartObject(formattedData)
      })), hasChartNote && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].chartNote
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: reportProps.chartNote
      }))) : /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].chartContent
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: _style["default"].blueHeader
      }, " No Report Data")))), reportProps.subScales && /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportWrapper
      }, this.props.header, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportContentWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].contentWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].flexCenter
      }, /*#__PURE__*/_react["default"].createElement("h1", null, this.props.reportProps.reportTitle), !isReport && 'withTooltip' in reportProps && reportProps.withTooltip && /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].tooltip
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: reportProps.tooltipSettings.content
        })),
        type: reportProps.tooltipSettings.type,
        placement: reportProps.tooltipSettings.position,
        maxWidth: reportProps.tooltipSettings.maxWidth
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))), this.props.reportProps.description && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: this.props.reportProps.description
      }), /*#__PURE__*/_react["default"].createElement("br", null)), !(0, _isUndefined2["default"])(this.state.currentSubscale) && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '20px'
        }
      }, /*#__PURE__*/_react["default"].createElement("h2", {
        style: {
          fontSize: '1.2em',
          marginBottom: '5px'
        }
      }, currentSubscaleObj.label), 'description' in currentSubscaleObj && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: currentSubscaleObj.description
      }), !isReport && 'withTooltip' in currentSubscaleObj && currentSubscaleObj.withTooltip && /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].tooltip
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: currentSubscaleObj.tooltipSettings.content
        })),
        type: currentSubscaleObj.tooltipSettings.type,
        placement: currentSubscaleObj.tooltipSettings.position,
        maxWidth: currentSubscaleObj.tooltipSettings.maxWidth
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].chartContent
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].barChart,
        key: this.state.currentSubscale ? this.state.currentSubscale : 1
      }, /*#__PURE__*/_react["default"].createElement(_cccisdDataviz["default"], {
        chartData: this._getSubChartObject(this.state.currentSubscale)
      }))), !this.props.isReport && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].detailsContent
      }, 'subScales' in this.props.reportProps && this._renderSubscales()))))), otherPages, reportProps.commentsPath !== '' && !(0, _isNil2["default"])(reportProps.commentsPath) ? /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportContentWrapper
      }, isReport && this.props.header, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].contentWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].commentsArea
      }, /*#__PURE__*/_react["default"].createElement("h1", null, "Comments"), !(0, _isEmpty2["default"])(this.props.comments) && this.props.comments.map(function (comment) {
        return /*#__PURE__*/_react["default"].createElement("div", null, _this2._renderCommentBox(comment.label, comment.date, comment.comment));
      }), (0, _isEmpty2["default"])(this.props.comments) && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].fade
      }, "No comment data")))))) : /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'none'
        }
      }), ' ')));
    }
  }]);
  return BarChartReportGroup;
}(_react.Component);
BarChartReportGroup.propTypes = {
  /**
   * [
   *   {
   *      handle: "session1",
   *      axislabel: "1",
   *      date: moment(),
   *      held: true,
   *      completed: false,
   *      fidelityScore: 67,
   *      ComponentCoverageScore: 95,
   *      DeliveryQualityScore: 85,
   *      ComplianceScore: 75,
   *      Dosage: 90,
   *   },
   *   {
   *      handle: "session2",
   *      axislabel: "2",
   *      date: moment(),
   *      held: false,
   *      completed: false,
   *      fidelityScore: 92,
   *      ComponentCoverageScore: 65,
   *      DeliveryQualityScore: 90,
   *      ComplianceScore: 72,
   *      Dosage: 81
   *   },
   *   . . .
   * ]
   */
  reportData: _propTypes["default"].array,
  reportProps: _propTypes["default"].object,
  isReport: _propTypes["default"].bool,
  /**
   * Full rendered markup for the header
   */
  header: _propTypes["default"].node,
  devMetricsMap: _propTypes["default"].object,
  comments: _propTypes["default"].array
};
var _default = exports["default"] = BarChartReportGroup;